import { integersFormatter } from '@carboncopyco/utils';
import { useState } from 'react';
import { OverviewTabChartCard } from '../../OverviewTabChartCard';
import { useActivityOverviewData } from '../../useActivityOverviewData';
import { usePlaybookPageProps } from '../PlaybookPageContext';
import type { TimePeriod } from '../types';

export const ActivityOverview = () => {
  const { organizationId, workspaceId, playbookId } = usePlaybookPageProps();
  const [timePeriod, setTimePeriod] = useState<TimePeriod>('30');
  const {
    chartData,
    nowData,
    isLoading,
    isLoadingPrevData,
    getPercentages,
    getDescription,
    isError,
  } = useActivityOverviewData({
    organizationId,
    workspaceId,
    timePeriod,
    assetId: playbookId,
    resourceTypes: ['play'],
  });

  const { values } = nowData?.results[0] ?? {};

  return (
    <OverviewTabChartCard
      subtitle="Demos given"
      description={getDescription('occurrences')}
      kpiNumber={
        values?.occurrences ? integersFormatter(values.occurrences) : ''
      }
      kpiRawNumber={values?.occurrences}
      kpiPercentage={getPercentages('occurrences')}
      timePeriod={timePeriod}
      setTimePeriod={setTimePeriod}
      negative={Number(getPercentages('occurrences')) < 0}
      isError={isError}
      isEmpty={!isLoading && !values?.occurrences}
      isLoading={isLoading || isLoadingPrevData}
      lineChartData={chartData}
      tooltipText="The number of times this playbook was presented during the specified period"
      chartName="Demos Given"
    />
  );
};
